import React from 'react';
import { Card, CardContent, Typography, List, ListItem, ListItemButton, ListItemText, Box, Chip } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';

interface HiddenPost {
  id: number;
  description: string;
  hiddenAt: string | null;
  hiddenReason: string | null;
  authorName: string;
}

const timeAgo = (iso: string) => {
  const diff = Date.now() - new Date(iso).getTime();
  const hrs = Math.floor(diff / 3600000);
  if (hrs < 24) return `${hrs}시간 전`;
  return `${Math.floor(hrs / 24)}일 전`;
};

const HiddenPostsList: React.FC<{ items: HiddenPost[] }> = ({ items }) => {
  const navigate = useNavigate();
  return (
    <Card sx={{ flex: '1 1 400px', minWidth: 0 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <VisibilityOffIcon color="warning" />
          <Typography variant="h6">최근 숨김 처리 게시물</Typography>
        </Box>
        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            숨김 처리된 게시물이 없습니다.
          </Typography>
        ) : (
          <List disablePadding>
            {items.map((p) => (
              <ListItem key={p.id} disablePadding>
                <ListItemButton onClick={() => navigate(`/posts/${p.id}`)}>
                  <ListItemText
                    primary={
                      <Typography variant="body2" noWrap>
                        {p.description || '(내용 없음)'}
                      </Typography>
                    }
                    secondary={
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                        <Typography variant="caption" color="text.secondary">
                          {p.authorName}
                        </Typography>
                        {p.hiddenAt && (
                          <Typography variant="caption" color="text.secondary">
                            · {timeAgo(p.hiddenAt)}
                          </Typography>
                        )}
                        {p.hiddenReason && (
                          <Chip label={p.hiddenReason} size="small" variant="outlined" />
                        )}
                      </Box>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};

export default HiddenPostsList;
